import { useEffect, useState } from 'react'
import { createPortal } from 'react-dom'
import { CONFETTI_MIN_DURATION, CONFETTI_DURATION_VARIATION, CONFETTI_MAX_DELAY, CONFETTI_END } from './winCelebrationTiming.js'

const colors = ['#2b8a46', '#86efac', '#facc15', '#38bdf8', '#fb7185', '#a78bfa']

export default function DealConfetti({ onEnd }) {
  const [pieces] = useState(() => Array.from({ length: 280 }, (_, index) => ({
    left: `${15 + Math.random() * 70}%`,
    background: colors[index % colors.length],
    width: `${5 + Math.random() * 5}px`,
    height: `${7 + Math.random() * 7}px`,
    '--drift': `${(Math.random() - .5) * 75}vw`,
    '--rise': `${-(80 + Math.random() * 25)}dvh`,
    '--spin': `${(Math.random() - .5) * 2160}deg`,
    animationDelay: `${index < 12 ? 0 : Math.random() * CONFETTI_MAX_DELAY}s`,
    animationDuration: `${CONFETTI_MIN_DURATION + (index < 12 ? 0 : Math.random() * CONFETTI_DURATION_VARIATION)}s`,
    borderRadius: index % 3 === 0 ? '50%' : '1px',
  })))
  useEffect(() => {
    const timer = setTimeout(onEnd, (CONFETTI_END + .1) * 1000)
    return () => clearTimeout(timer)
  }, [onEnd])
  return createPortal(<div className="dp-confetti" aria-hidden="true">{pieces.map((style, index) => <i key={index} style={style} />)}</div>, document.body)
}
